'use client'

import EmptyState from "../elements/EmptyState"
import BlogCard from "../blog/BlogCard"
import { BookOpenText, MoveRight } from "lucide-react"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function Blogs({ blogs, title, limit, description }: { blogs: any[], title?: string, limit?: number, description?: string }) {
  const pathname = usePathname()
  const displayBlogs = limit ? blogs.slice(0, limit) : blogs

  return (
    <section className="w-full px-4 lg:px-6 py-12 lg:py-16">
      <div className="flex items-end justify-between gap-6 mb-6 lg:mb-8">
        <div className="min-w-0">
          <h2 className="text-2xl sm:text-4xl tracking-tight text-foreground">{title || 'Нийтлэл'}</h2>
          {description && <p className="mt-2 text-sm text-muted-foreground">{description}</p>}
        </div>
        {displayBlogs?.length > 0 && (
          <a href={navigateUrl('/blog', pathname)} className="group shrink-0 inline-flex items-center gap-1.5 text-[13px] tracking-wide focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">
            <span className="pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none">Бүгдийг харах</span>
            <MoveRight className="size-3.5" strokeWidth={1.5} />
          </a>
        )}
      </div>
      {displayBlogs?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-1">
          {displayBlogs.map((blog: any, index: number) => (
            <BlogCard key={blog.id} blog={blog} index={index} />
          ))}
        </div>
      ) : (
        <EmptyState icon={BookOpenText} title="Нийтлэл хоосон байна" description="Яг одоогоор нийтлэл оруулаагүй байна. Хэсэг хугацааны дараа дахин шалгана уу." />
      )}
    </section>
  )
}
